import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { LINKED_IN_BUSINESS_COLOR } from "../../../../constants/socialColors.constant";
import { IconProps } from "../Facebook/FacebookIcon";

export const LinkedInBusinessIcon = (props: IconProps) => {
  const { active, className, size, color } = props;
  return (
    <FontAwesomeIcon
      style={{
        color: color || (active ? LINKED_IN_BUSINESS_COLOR : "gray"),
      }}
      icon={["fab", "linkedin"]}
      className={className}
      size={size}
    />
  );
};
